import React from 'react';
import PropTypes from 'prop-types';

const Helper = ({ children, type }) => (
  <span className={type || 'info'}>{children}</span>
);

Helper.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
};

export default Helper;



// WEBPACK FOOTER //
// ./src/components/AppForm/Helper.jsx